





































































import { Paths } from '@/router';
import { WorkerService } from '@/services/WorkerService';
import { Mutations } from '@/store';
import BButton from 'buefy/src/components/button/Button.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: { BButton },
})
export default class Home extends Vue {
  private padStyle: any = {
    ['background-color']: 'white',
  };

  private firstName: string = '';
  private lastName: string = '';
  private email: string = '';

  private validate(): boolean {
    return !(this.$refs as any).signaturePad.isEmpty();
  }

  private async register() {
    if (this.validate()) {
      const { data } = (this.$refs as any).signaturePad.saveSignature();

      try {
        await WorkerService.createWorker({
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          signatureImage: data,
        });

        const worker = await WorkerService.getWorker();

        this.$store.commit(Mutations.SET_WORKER, worker);
        this.$router.push({ name: Paths.WORK_LOGS });
      } catch (err) {
        console.error('Could not create worker!', err);
      }
    } else {
      console.log('Validation error!');
    }
  }

  private undo() {
    (this.$refs as any).signaturePad.undoSignature();
  }
}
